export default class InitialLoadUtils {
    public static injectInitialLoader(): void {
        const initialLoadHTML =
            "<div id='initial-load'><div class='spinner'><div class='leftWrapper'><div class='left'><div class='circle' style='position: absolute;'></div></div></div><div class='rightWrapper'><div class='right'><div class='circle'></div></div></div></div></div>";
        const initialLoad = new DOMParser().parseFromString(initialLoadHTML, "text/html").body.firstElementChild as HTMLElement;
        window.document.body.appendChild(initialLoad);

        const resize = (): void => {
            initialLoad.style.width = window.innerWidth + "px";
            initialLoad.style.height = window.innerHeight + "px";
        };
        window.addEventListener("resize", resize);
        window.addEventListener("load", resize);
        resize();

        initialLoad.addEventListener("animationend", (): void => {
            initialLoad.style.display = "none";
        });
    }

    public static hideInitialLoader(): void {
        const initialLoad = window.document.getElementById("initial-load");
        if (initialLoad) initialLoad.className = "fadeOut";
    }
}
